<template>
  <div>
    <a-row>
      <a-spin :spinning="profileLoading">
        <a-col :md="12" style="text-align: -webkit-center;">
          <a-card hoverable style="max-width: 250px;">
            <div slot="cover" style="overflow: hidden; height: 150px; ">
              <img
                alt="Profile"
                :src="profileSrc"
                style="width: 100%; max-width: 150px; border-radius: 20px"
              />
            </div>
            <template class="ant-card-actions" slot="actions">
              <a-icon v-if="mostrarActualizarInformacionDashboard" type="edit" key="edit"
                      @click="() => {modalActualizarVisible = true}"/>
              <a-icon type="dollar" key="mypayroll" @click="() => {modalMyPayrollVisible = true}"
                      style="color: green;"/>
              <a-icon type="container" key="histSol" @click="() => {modalHistorialSolicitudes = true}"
                      style="color: green;"/>
            </template>
            <a-card-meta :title="profileData.nombre" :description="profileData.cargo">
            </a-card-meta>
          </a-card>
          <modal-actualizar-datos :visible="modalActualizarVisible"
                                  :profile="profileData"
                                  @cancel="()=>{modalActualizarVisible=false}"
                                  @success="()=>{modalActualizarVisible=false; loadProfileData()}"></modal-actualizar-datos>
          <modal-my-payroll :visible="modalMyPayrollVisible"
                            @ok="() => {modalMyPayrollVisible = false}"></modal-my-payroll>
          <modal-historico-solicitudes :visible="modalHistorialSolicitudes"
                                       @ok="() => {modalHistorialSolicitudes = false}"></modal-historico-solicitudes>
        </a-col>
        <a-col :md="12" :xs="0" style="text-align: -webkit-center;">
          <a-card hoverable style="max-width: 250px;">
            <div slot="cover" style="overflow: hidden; height: 150px;">
              <img
                alt="Company"
                :src="companySrc"
                style="width: 100%; margin-top: 20px;"
              />
            </div>
            <template class="ant-card-actions" slot="actions">
              <a-popover title="Detalles">
                <template slot="content">
                  <p>{{profileData.att1}}: {{profileData.desc_att1}}</p>
                  <p>{{profileData.att2}}: {{profileData.desc_att2}}</p>
                  <p>{{profileData.att3}}: {{profileData.desc_att3}}</p>
                  <p>{{profileData.att4}}: {{profileData.desc_att4}}</p>
                  <p>{{profileData.att5}}: {{profileData.desc_att5}}</p>
                </template>
                <a-icon type="ellipsis" key="ellipsis"/>
              </a-popover>
              <a-icon type="apartment" key="myTeam" @click="() => {modalMyTeam = true}"
                      style="color: green;"/>
            </template>
            <a-card-meta :title="profileData.compania" :description="profileData.localidad">
            </a-card-meta>
          </a-card>
          <modal-my-team :visible="modalMyTeam"
                         v-if="modalMyTeam"
                         @ok="() => {modalMyTeam = false}"></modal-my-team>
        </a-col>
      </a-spin>
    </a-row>
    <a-row> &nbsp;</a-row>
    <a-row v-if="noteLoading">
      <a-col style="text-align: center">
        <a-spin :spinning="noteLoading">
        </a-spin>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :md="6" :sm="12" v-for="infoNote in infoNotes">
        <info-note :icon="infoNote.icono" :icon-color="infoNote.icon_color" :title="infoNote.valor"
                   :subtitle="infoNote.titulo"
                   :bg-color="infoNote.color" border-color="" :detalle="infoNote.detalle"></info-note>
      </a-col>
    </a-row>
    <a-row> &nbsp;</a-row>
    <a-row> &nbsp;</a-row>
    <a-row :gutter="16">
      <a-col :sm="24" :md="mdDiasPorAusencia">
        <canvas id="diasPeriodo" width="400" height="400"></canvas>
      </a-col>
      <a-col :sm="24" :md="16" v-if="mostrarDiasPorAusencia">
        <canvas id="diasPorAusencias" width="400" height="400"></canvas>
      </a-col>
    </a-row>
    <a-row>
      &nbsp;
    </a-row>
    <a-row>
      &nbsp;
    </a-row>
    <a-row style="text-align: right">
      <template>
        <btn-solicitar-vacaciones @success="actualiziarSolicitudes"
                                  v-if="mostrarBotonVacaciones"></btn-solicitar-vacaciones>
        <btn-solicitar-permisos ref="solicitarPermiso" @success="actualiziarSolicitudes"
                                v-if="mostrarBotonPermisos"></btn-solicitar-permisos>
        <btn-solicitar-recuperacion ref="solicitarRecuperacion" @success="actualiziarSolicitudes"
                                    v-if="mostrarBotonPermisosRecuperacion"></btn-solicitar-recuperacion>
      </template>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1" v-if="$getConfigValue('MOSTRAR_NOTAS', false) === 'SI' && (alertas.length > 0 || permisosAlerta)">
        <a-tab-pane key="1">
           <span slot="tab">
             <a-icon type="book"/>
             Alertas
           </span>
          <a-button v-if="permisosAlerta" icon="plus" @click="agregarAlertaModal()">
            Agregar alerta
          </a-button>
          <br>
          <div>
            <a-spin :spinning="loadingAlertas">
              <div clreass="center">
                <div :gutter="[16,16]">
                  <a-col v-if="alertas.length !== 0" style="padding: 3px"
                         :xs="{span: 24 }"
                         :sm="{span: alerta.size}"
                         :md="{span: alerta.size}"
                         :lg="{span: alerta.size}"
                         v-for="alerta in alertas">
                    <a-card hoverable size="small">
                      <a-card-meta>
                        <div slot="description" v-html="alerta.html"/>
                      </a-card-meta>
                      <template slot="actions" class="ant-card-actions">
                        <a-icon v-if="alerta.images.length > 0 || permisosAlerta" key="file-image" type="file-image" @click="registroFotografico(alerta)"/>
                        <a-icon v-if="permisosAlerta" key="edit" type="edit" @click="editarAlertaModal(alerta)"/>
                        <a-icon v-if="permisosAlerta" key="delete" type="delete" @click="eliminarAlertaModal(alerta)"/>
                      </template>
                    </a-card>
                  </a-col>
                </div>
              </div>
            </a-spin>
          </div>
          <a-alert
            v-if="alertas.length === 0"
            message="Información"
            description="Actualmente no hay alertas."
            type="info"
            show-icon
          />
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
          <span slot="tab">
             <a-icon type="reconciliation"/>
             Mis solicitudes
           </span>
          <g-datatable :columns="vacaciones.tableSetup.columns"
                       :endpoint="vacaciones.endpoint"
                       :tableConfig="vacaciones.tableSetup.tableConfig"
                       :requestData="vacaciones.tableSetup.requestData"
                       :customSlots="vacaciones.tableSetup.customSlots"
                       :actions="vacaciones.tableSetup.actions"
                       @action="permisosAction"
                       ref="datatable">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag :color="text==='PENDIENTE' ? 'purple' : (text === 'APROBADA' ? 'green' : 'cyan')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
          <span slot="tab">
             <a-icon type="project"/>
             Solicitudes por gestionar
           </span>
          <g-datatable :columns="vacaciones2.tableSetup.columns"
                       :endpoint="vacaciones2.endpoint"
                       :tableConfig="vacaciones2.tableSetup.tableConfig"
                       :requestData="vacaciones2.tableSetup.requestData"
                       :customSlots="vacaciones2.tableSetup.customSlots"
                       :actions="vacaciones2.tableSetup.actions"
                       ref="datatable2"
                       @action="solicitudesAction">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag
                              :color="(text==='PENDIENTE' || text==='RECHAZADA') ? 'red' : (text === 'APROBADA' ? 'green' : 'purple')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">
             <a-icon type="file-search"/>
             Requisiciones por gestionar
           </span>
          <g-datatable :columns="requisiciones.tableSetup.columns"
                       :endpoint="requisiciones.endpoint"
                       :tableConfig="requisiciones.tableSetup.tableConfig"
                       :requestData="requisiciones.tableSetup.requestData"
                       :customSlots="requisiciones.tableSetup.customSlots"
                       :actions="requisiciones.tableSetup.actions"
                       ref="requisicionesTable"
                       @action="requisicionesAction">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag :color="text==='RECHAZADA' ? 'red' : (text === 'CERRADA' ? 'green' : 'blue')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <!-- modal de vacaciones permisos y paz y salvo -->
    <a-modal title="Confirmación"
             :visible="confirmVisible"
             @ok="confirmarConfirmacionAprobar"
             :confirmLoading="confirmLoading"
             @cancel="cancelarConfirmacionAprobar">
      <p>
        ¿Está seguro de {{arpobarRechazar.aprobar ? 'aprobar' : 'rechazar'}} la solicitud de
        {{arpobarRechazar.tipo_solicitud}}?</p>
      <a-form-item label="Observaciones" v-if="canViewObs">
        <a-textarea autoSize v-model="arpobarRechazar.observacion"></a-textarea>
      </a-form-item>
      <a-alert type="error" :message="confirmMensaje" v-if="confirmMensaje != ''"/>
    </a-modal>

    <a-modal title="Confirmación"
             :visible="requisiciones.confirmVisible"
             @ok="confirmarAprobarRechazarRequisicion"
             :confirmLoading="requisiciones.confirmLoading"
             @cancel="cancelarAprobarRechazarRequisicion">
      <p>
        ¿Está seguro de {{requisiciones.arpobarRechazar.aprobar ? 'aprobar' : 'rechazar'}} la Requisición?</p>
      <a-alert type="error" :message="requisiciones.confirmMensaje" v-if="requisiciones.confirmMensaje != ''"/>
    </a-modal>

    <a-modal v-model="modalAgregarAlerta" title="Crear / Editar" :confirm-loading="formularioAlertaLoading"
             @ok="guardarAlerta" @cancel="cancelarAlerta">
      <a-form-model :model="formularioAlerta" ref="formularioAlerta">
        <a-form-model-item :label="$t('Descripción')" prop="html"
                           :rules="[{ required: true, message: 'Valor requerido' }]">
          <a-textarea autoSize v-model="formularioAlerta.html"></a-textarea>
        </a-form-model-item>
        <a-form-model-item :label="$t('Roles')" prop="rol">
          <form-model-dropdown endpoint="role"
                               :label="$t('Rol') "
                               :selectConfig="{mode:'multiple'}"
                               v-model="formularioAlerta.rol"
          >
          </form-model-dropdown>
        </a-form-model-item>
        <a-form-model-item :label="$t('Tamaño')" prop="size">
          <a-select style="width: 100%" v-model="formularioAlerta.size">
            <a-select-option v-for="tamano in tamanos" :key="tamano.value">
              {{ tamano.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="$t('Orden')" prop="order">
          <a-input-number style="width: 100%;" v-model="formularioAlerta.order"></a-input-number>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="Confirmación"
             :visible="modalEliminarAlerta"
             @ok="confirmarEliminarAlerta"
             :confirmLoading="loadingEliminaAlerta"
             @cancel="modalEliminarAlerta = false">
      <p>¿Está seguro que desea eliminar esta alerta?</p>
    </a-modal>

    <a-modal title="Registro fotográfico"
             :visible="modalRegistroFotografico"
             :footer="null"
             width="80%"
             @cancel="()=>{modalRegistroFotografico = false; fotoAModificar = null}"
    >
      <input v-show="false" ref="file" accept="image/*" style="display: none" type="file"
             v-on:change="fileSelected($event)">
      <a-button v-if="fotoAModificar" style="border: none; padding: 0">
        <a-avatar shape="square" style="margin-bottom: 3px" :src="fotoAModificar"></a-avatar>
      </a-button>
      <a-button v-if="permisosAlerta" @click="selectFile()" icon="file-image">
        Cargar imagen
      </a-button>
      <a-button v-if="fotoAModificar" icon="save" :loading="loadingGuardarImagen" @click="guardarImagen">
        <div></div>
      </a-button>
      <a-button v-if="fotoAModificar" icon="delete" @click="()=>{fotoAModificar = null}">
        <div></div>
      </a-button>
      <div v-if="alertaSeleccionada.hasOwnProperty('images') && alertaSeleccionada.images.length === 0">
        <br>
        Aún no se han registrado fotos en esta alerta.
      </div>
      <a-spin v-if="alertaSeleccionada.hasOwnProperty('imagenes_renderizadas')" :key="key"
              :spinning="loadingRegistroFotoGrafico">
        <a-row :gutter="[16,16]">
          <a-col v-if="alertas.length !== 0" style="margin-top: 10px" :xs="{span: 24 }" :sm="{span: 24}"
                 :md="{span: 24}"
                 :lg="{span: 24}" v-for="(image) in alertaSeleccionada.imagenes_renderizadas">
            <a-card style="text-align: center">
              <img style="width: 100%; height: auto" :src="image.base64">
              <template slot="actions" class="ant-card-actions">
                <a-icon v-if="permisosAlerta" key="delete" type="delete" @click="eliminarImagen(image)"/>
              </template>
            </a-card>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
  import Chart from 'chart.js'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  function getRandomColor () {
    let letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  export default {
    data () {
      let ocultarComoRecupera = this.$getConfigValue('DASHBOARD_SOL_OCULTA_COMO_RECUPERA', 'NO') !== 'NO'
      /* Si este filtro es SI muestra solo las solicitudes pendientes de aprobación en mis solicitudes */
      let filtroSolicitudesPorAprobar = this.$getConfigValue('DASHBOARD_MIS_SOL_FITRAR_PENDIENTES', 'SI')
      let solicitudesPendientesRequestData = {tipo: 2}
      if (filtroSolicitudesPorAprobar === 'SI') {
        solicitudesPendientesRequestData.estado = 'PENDIENTE'
      }
      return {
        key: 0,
        tamanos: [{
          'value': '24',
          'name': 'COMPLETO'
        }, {
          'value': '12',
          'name': 'MEDIO'
        }, {
          'value': '8',
          'name': 'TRES CUARTOS'
        }],
        loadingGuardarImagen: false,
        loadingRegistroFotoGrafico: false,
        arregloDeImagenes: [],
        alertas: [],
        alertaSeleccionada: {},
        foto: null,
        alertaAEliminar: {},
        fotoAModificar: null,
        archivoFotografico: null,
        modalRegistroFotografico: false,
        loadingEliminaAlerta: false,
        loadingAlertas: false,
        formularioAlertaLoading: false,
        modalAgregarAlerta: false,
        modalEliminarAlerta: false,
        formularioAlerta: {
          html: null,
          rol: [],
          order: null,
          size: '24'
        },
        loadingBtns: {},
        noteLoading: true,
        mdDiasPorAusencia: 8,
        infoNote: {
          fechaIngreso: '-/-/-',
          salario: '-',
          vacaciones: '-',
          descuentoRetenciones: '-'
        },
        infoNotes: [],
        profileData: {},
        profileLoading: true,
        profileSrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        companySrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        canvas: {
          diasPorPeriodo: null,
          diasPorAusencias: null
        },
        confirmVisible: false,
        confirmLoading: false,
        confirmMensaje: '',
        arpobarRechazar: {},
        modalActualizarVisible: false,
        vacaciones: {
          endpoint: 'ss/dashboard/vacaciones',
          tableSetup: {
            columns: [
              {title: '#', dataIndex: 'id', sorter: true, width: 100},
              {title: 'Solicitud', dataIndex: 'tipo_solicitud', sorter: true, width: 200},
              {title: 'F. Ini', dataIndex: 'fecha_inicio', sorter: true, width: 100},
              {title: 'F. Fin', dataIndex: 'fecha_fin', sorter: true, width: 100},
              {
                title: this.$t('UNIDAD_MEDIDA_DIAS_SOLICITUDES_DASHBOARD'),
                dataIndex: 'cantidad',
                sorter: true,
                width: 120
              },
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'H. Ini', dataIndex: 'tiempo_inicio', sorter: true, width: 90},
              {title: 'H. Fin', dataIndex: 'tiempo_fin', sorter: true, width: 90},
              {title: 'Tipo', dataIndex: 'tipo_permiso', sorter: true, width: 150},
              {title: 'Sub Tipo', dataIndex: 'subtipo_permiso', sorter: true, width: 120},
              {title: 'Aprobador', dataIndex: 'nombre_jefe', sorter: true},
              {title: 'Observaciones', dataIndex: 'observacion', sorter: true},
              ...(!ocultarComoRecupera ? {title: 'Cómo Recupera', dataIndex: 'como_recupera', sorter: true} : [])
            ],
            tableConfig: {
              // scroll: {x: 1600, y: 250},
              rowKey: 'rowid'
            },
            requestData: {tipo: 1},
            customSlots: ['estadoRenderer'],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 90,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE' &&
                      record.tipo_solicitud !== 'RECUPERACION PERMISO PERSONAL' &&
                      record.tipo_solicitud !== 'VACACIONES' &&
                      record.tipo_solicitud !== 'PAZ Y SALVO'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE' && record.tipo_solicitud !== 'PAZ Y SALVO'
                  }
                },
                {
                  name: 'descargar',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:red;'},
                  fnVisible: (record) => {
                    return record.hasOwnProperty('file_path') && record.file_path && this.canUploadVacationFiles
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            }
          }
        },
        vacaciones2: {
          endpoint: 'ss/dashboard/vacaciones',
          tableSetup: {
            columns: [
              {title: '#', dataIndex: 'id', sorter: true, width: 100},
              {title: 'Solicitud', dataIndex: 'tipo_solicitud', sorter: true, width: 200},
              {title: 'Nombre Solicitante', dataIndex: 'nombre_solicitante', sorter: true},
              {title: 'Unidad', dataIndex: 'unidad_tiempo', sorter: true, width: 120},
              {title: 'Tiempo', dataIndex: 'cantidad', sorter: true, width: 120},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'F. Ini', dataIndex: 'fecha_inicio', sorter: true, width: 100},
              {title: 'F. Fin', dataIndex: 'fecha_fin', sorter: true, width: 100},
              {title: 'H. Ini', dataIndex: 'tiempo_inicio', sorter: true, width: 90},
              {title: 'H. Fin', dataIndex: 'tiempo_fin', sorter: true, width: 90},
              {title: 'Tipo', dataIndex: 'tipo_permiso', sorter: true, width: 150},
              {title: 'Sub Tipo', dataIndex: 'subtipo_permiso', sorter: true, width: 120},
              {title: 'Observaciones', dataIndex: 'observacion', sorter: true},
              ...(!ocultarComoRecupera ? {title: 'Cómo Recupera', dataIndex: 'como_recupera', sorter: true} : [])
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 120,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE'
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'close',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible (record) {
                    return record.estado === 'PENDIENTE'
                  }
                },
                {
                  name: 'descargar',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.has_file
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                },
                {
                  name: 'descargar_vacaciones',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:red;'},
                  fnVisible: (record) => {
                    return record.hasOwnProperty('file_path') && record.file_path && this.canUploadVacationFiles
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'rowid'
            },
            requestData: solicitudesPendientesRequestData,
            customSlots: ['estadoRenderer']
          }
        },
        requisiciones: {
          confirmVisible: false,
          confirmLoading: false,
          arpobarRechazar: {},
          confirmMensaje: '',
          loadingBtns: {},
          endpoint: 'gestion_humana/requisiciones',
          tableSetup: {
            columns: [
              {title: 'Req.', dataIndex: 'req_id', sorter: true, width: 100},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Motivo', dataIndex: 'motivo', sorter: true},
              {title: 'Cargo Solicitado', dataIndex: 'cargo', sorter: true},
              {title: 'Solicitado Por', dataIndex: 'solicitado_por', sorter: true},
              {title: 'Oficina', dataIndex: 'oficina', sorter: true},
              {title: 'Prospecto', dataIndex: 'prospecto', sorter: true}
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 90,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return this.canApprove(record)
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.canReject(record)
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'finalizar',
                  text: 'Finalizar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.estado === 'ABIERTA'
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'cerrar',
                  text: 'Cerrar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.estado === 'FINALIZADA'
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'req_id'
            },
            requestData: {},
            customSlots: ['estadoRenderer', 'customAction']
          }
        },
        modalMyPayrollVisible: false,
        modalHistorialSolicitudes: false,
        modalMyTeam: false,
        canUploadVacationFiles: this.$getConfigValue('SUBIR_ARCHIVOS_VACACIONES_DASHBOARD', 'NO') === 'SI',
        status: {
          REQUISICIONES_ETAPA_INICIADA: '00'
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadInfoNote()
      this.loadProfileData()
      this.initDiasPorPeriodo()
      this.initDiasPorAusencias()
      this.status.REQUISICIONES_ETAPA_INICIADA = this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00')
      this.consultarAlertas()
      this.validaUsuario()
    },
    methods: {
      eliminarImagen (image) {
        this.httpClient.getInstance().delete('alertas/eliminar_imagen', {
          data: {
            imagen: image,
            alerta_seleccionada: this.alertaSeleccionada
          }
        })
          .then(response => {
            this.consultarAlertas(true)
            Mensajes.success('Correcto', 'Se eliminó correctamente la imagen.')
          })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible eliminar la imagen, por favor contacte a un administrador')
          })
          .then(() => {
          })
      },
      registroFotografico (alerta) {
        this.modalRegistroFotografico = true
        setTimeout(() => {
          this.loadingRegistroFotoGrafico = true
          this.alertaSeleccionada = alerta
          let arregloTemporalImagenes = []
          if (this.alertaSeleccionada.images.length > 0) {
            for (let image of this.alertaSeleccionada.images) {
              this.httpClient.getInstance().get('render_image', {
                params: {ruta: image},
                responseType: 'arraybuffer'
              })
                .then((response) => {
                  let blob = new Blob([response.data], {type: response.headers['content-type']})
                  arregloTemporalImagenes.push({base64: window.URL.createObjectURL(blob), key: image})
                  this.key++
                }).catch(error => {
                })
                .then(() => {
                })
            }
            this.alertaSeleccionada['imagenes_renderizadas'] = arregloTemporalImagenes
            this.loadingRegistroFotoGrafico = false
          } else {
            this.alertaSeleccionada['imagenes_renderizadas'] = []
            this.loadingRegistroFotoGrafico = false
          }
        }, 500)
      },
      selectFile () {
        let fileInputElement = this.$refs.file
        fileInputElement.click()
      },
      fileSelected (event) {
        let file = event.target.files[0]
        this.archivoFotografico = event.target.files[0]
        let reader = new FileReader()
        reader.onload = (e) => {
          let fileData = e.target.result
          this.fotoAModificar = fileData
        }
        reader.readAsDataURL(file)
      },
      guardarImagen () {
        this.loadingGuardarImagen = true
        let reqFormData = new FormData()
        reqFormData.append('imagen', this.archivoFotografico)
        reqFormData.append('id', JSON.stringify(this.alertaSeleccionada.id))
        this.httpClient.getInstance().post('alertas/guardar_imagen', reqFormData)
          .then(() => {
            Mensajes.success('Correcto', 'Imagen guardada correctamente')
            this.consultarAlertas(true)
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          }).then(() => {
            this.loadingGuardarImagen = false
          })
      },
      consultarAlertas (renderImage = null) {
        this.loadingAlertas = true
        this.httpClient.getInstance().get('consultar_alertas', {
          params: this.formularioAlerta
        })
          .then(response => {
            this.alertas = response.data
            if (renderImage) {
              this.alertaSeleccionada = this.alertas.filter(item => item.id === this.alertaSeleccionada.id)
              this.registroFotografico(this.alertaSeleccionada[0])
            }
          })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible consultar la alertas, por favor contacte a un administrador')
          })
          .then(() => {
            this.loadingAlertas = false
          })
      },
      agregarAlertaModal () {
        this.formularioAlerta.order = null
        this.formularioAlerta.html = null
        this.formularioAlerta.rol = undefined
        this.formularioAlerta.size = '24'
        this.modalAgregarAlerta = true
        this.formularioAlerta.accion = 'create'
      },
      eliminarAlertaModal (alerta) {
        this.modalEliminarAlerta = true
        this.alertaAEliminar = alerta
      },
      confirmarEliminarAlerta () {
        this.loadingEliminaAlerta = true
        this.httpClient.getInstance().delete('eliminar_alerta', {
          data: {
            alerta: this.alertaAEliminar
          }
        })
          .then(response => {
            this.consultarAlertas()
            Mensajes.success('Correcto', 'Se eliminó correctamente la alerta.')
            this.modalEliminarAlerta = false
          })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible eliminar la alerta, por favor contacte a un administrador')
          })
          .then(() => {
            this.loadingEliminaAlerta = false
          })
      },
      editarAlertaModal (alerta) {
        this.formularioAlerta.rol = this.$isEmpty(alerta.rol) ? undefined : alerta.rol.split(',')
        this.formularioAlerta.html = alerta.html
        this.formularioAlerta.id = alerta.id
        this.formularioAlerta.order = alerta.order
        this.formularioAlerta.size = alerta.size
        this.formularioAlerta.accion = 'edit'
        this.modalAgregarAlerta = true
      },
      guardarAlerta () {
        this.$refs.formularioAlerta && this.$refs.formularioAlerta.validate(valid => {
          if (valid) {
            this.formularioAlertaLoading = true
            this.httpClient.getInstance().post('guardar_alerta', this.formularioAlerta)
              .then(response => {
                this.consultarAlertas()
                let mensaje = null
                if (this.formularioAlerta.accion === 'create') {
                  mensaje = 'Se registró correctamente la alerta.'
                } else {
                  mensaje = 'Se editó correctamente la alerta.'
                }
                Mensajes.success('Correcto', mensaje)
                this.cancelarAlerta()
                this.modalAgregarAlerta = false
              })
              .catch(error => {
                Mensajes.error('Error', 'No fue posible guardar la alerta, por favor contacte a un administrador')
              })
              .then(() => {
                this.formularioAlertaLoading = false
              })
          }
        })
      },
      cancelarAlerta () {
        this.$refs.formularioAlerta.resetFields()
      },
      consultarDatosGrafica (endpoint, resolve, reject, final) {
        this.httpClient.getInstance()
          .get(endpoint)
          .then((response) => resolve && resolve(response))
          .catch((error) => reject && reject(error))
          .then((e) => final && final(e))
      },
      initDiasPorPeriodo () {
        let ok = (response) => {
          let result = response.data

          let bgColors = []
          let borderColors = []
          result.values.map(() => {
            let color = Chart.helpers.color(getRandomColor())
            bgColors.push(color.alpha(0.5).rgbString())
            borderColors.push(color.rgbString())
          })

          this.canvas.diasPorPeriodo = new Chart('diasPeriodo', {
            type: 'bar',
            data: {
              labels: result.labels,
              datasets: [{
                // label: 'Dias por año',
                data: result.values,
                backgroundColor: bgColors,
                borderColor: borderColors,
                borderWidth: 1
              }]
            },
            options: {
              title: {
                display: true,
                text: this.$t('Vacaciones Disponibles')
              },
              legend: false,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }

        this.consultarDatosGrafica('ss/dashboard/dias_por_periodo', ok)
      },
      initDiasPorAusencias () {
        let ok = (response) => {
          let result = response.data

          result.datasets.map((dataset) => {
            let color = Chart.helpers.color(getRandomColor())
            dataset.backgroundColor = color.alpha(0.5).rgbString()
            dataset.borderColor = color.rgbString()
            dataset.borderWidth = 1
          })

          this.canvas.diasPorAusencias = new Chart('diasPorAusencias', {
            type: 'bar',
            data: {
              labels: result.labels,
              datasets: result.datasets
            },
            options: {
              title: {
                display: true,
                text: 'Ausencias'
              },
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.consultarDatosGrafica('ss/dashboard/dias_por_ausencia', ok)
      },
      loadInfoNote () {
        this.http = new HttpUtil('ss/dashboard/info_note')

        this.http.get(null, (response) => {
          this.infoNotes = response.data
        }, () => {
          Mensajes.error('Error', 'No fue posible cargar los datos del dashboard')
        }).then(() => {
          this.noteLoading = false
        })
      },
      loadProfileData () {
        this.httpClient.getInstance().get('ss/dashboard/get_profile_data').then((response) => {
          this.profileData = response.data
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar los datos del perfil')
        }).then(() => {
          this.profileLoading = false
        })

        this.http.getInstance().get('picture_service/render/profile', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            // no nos interesa
          })

        this.http.getInstance().get('picture_service/render/company', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.companySrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            // no nos interesa
          })
      },
      solicitudesAction (event) {
        switch (event.action) {
          case 'aprobar':
            this.aprobarVacaciones(event.record, true)
            break
          case 'rechazar':
            this.aprobarVacaciones(event.record, false)
            break
          case 'descargar':
            this.descargarAdjunto(event.record)
            break
          case 'descargar_vacaciones':
            this.descargarAdjunto(event.record, 'ss/solicitar_vacaciones/download/')
            break
        }
      },
      aprobarVacaciones (record, aprobar) {
        this.confirmVisible = true
        this.confirmMensaje = ''
        this.arpobarRechazar = {
          id: record.id,
          aprobar: aprobar,
          tipo_solicitud: record.tipo_solicitud,
          observacion: ''
        }
      },
      confirmarConfirmacionAprobar () {
        this.confirmLoading = true
        this.httpClient.getInstance().post('ss/dashboard/aprobar_rechazar_solicitud', this.arpobarRechazar)
          .then((response) => {
            let data = response.data
            if (parseInt(data.resultado) === 0) {
              this.confirmMensaje = data.mensaje
            } else {
              /* pendiente actualizar la tabla */
              Mensajes.success('Correcto', data.mensaje)
              this.$refs.datatable2.loadData()
              this.confirmMensaje = ''
              this.confirmVisible = false
              this.confirmLoading = false
            }
          })
          .catch(() => {
            Mensajes.error('No fue posible ejecutar la operación.')
          })
          .then(() => {
            if (this.confirmMensaje === '') {
              this.cancelarConfirmacionAprobar()
            }
            this.confirmLoading = false
          })
      },
      cancelarConfirmacionAprobar () {
        if (this.confirmLoading) return
        this.confirmVisible = false
        this.confirmMensaje = ''
        this.arpobarRechazar = {}
      },
      actualiziarSolicitudes () {
        this.$refs.datatable.loadData()
      },
      descargarAdjunto (record, endpoint = 'ss/solicitar_permisos/download/') {
        /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
        this.$nextTick(() => {
          this.loadingBtns[record.id] = record.id
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })

        this.httpClient.getInstance().post(endpoint + record.id, {}, {responseType: 'arraybuffer'})
          .then(response => {
            let fileURL = new Blob([response.data], {type: response.headers['content-type']})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }

            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
            fileLink.click()
          })
          .catch(() => {
            this.$notification.error({
              message: 'Error descargando',
              description: 'No fue posible descargar el archivo, contacte al administrador.',
              duration: 1
            })
          })
          .then(() => {
            delete this.loadingBtns[record.id]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
      },

      requisicionesAction (event) {
        switch (event.action) {
          case 'aprobar':
            this.aprobarRequisicion(event.record, true)
            break
          case 'rechazar':
            this.aprobarRequisicion(event.record, false)
            break
          case 'finalizar':
            // this.descargarAdjunto(event.record)
            break
          case 'cerrar':
            // this.descargarAdjunto(event.record)
            break
        }
      },
      aprobarRequisicion (record, aprobar) {
        this.requisiciones.confirmVisible = true
        this.requisiciones.arpobarRechazar = {
          req_id: record.req_id,
          aprobar: aprobar
        }
      },
      cancelarAprobarRechazarRequisicion () {
        if (this.requisiciones.confirmLoading) return
        this.requisiciones.confirmVisible = false
        this.requisiciones.confirmMensaje = ''
        this.requisiciones.arpobarRechazar = {}
      },
      confirmarAprobarRechazarRequisicion () {
        this.requisiciones.confirmLoading = true
        this.httpClient.getInstance().post('gestion_humana/requisiciones/aprobar_rechazar_solicitud', this.requisiciones.arpobarRechazar)
          .then((response) => {
            let data = response.data
            if (parseInt(data.resultado) === 0) {
              this.requisiciones.confirmMensaje = data.mensaje
            } else {
              /* pendiente actualizar la tabla */
              Mensajes.success('Correcto', data.mensaje)
              this.$refs.requisicionesTable.loadData()
              this.requisiciones.confirmMensaje = ''
              this.requisiciones.confirmVisible = false
              this.requisiciones.confirmLoading = false
            }
          })
          .catch(() => {
            Mensajes.error('No fue posible ejecutar la operación.')
          })
          .then(() => {
            if (this.requisiciones.confirmMensaje === '') {
              this.cancelarConfirmacionAprobar()
            }
            this.requisiciones.confirmLoading = false
          })
      },
      permisosAction (event) {
        switch (event.action) {
          case 'masterEdit':
            if (event.record.tipo_solicitud === 'VACACIONES') {
              this.$refs.solicitarVacaciones && this.$refs.solicitarVacaciones.showModal(event.record)
            } else {
              this.$refs.solicitarPermiso && this.$refs.solicitarPermiso.showModal(event.record)
            }
            break
          case 'masterDelete':
            let endpoint = 'permission_req/'
            if (event.record.tipo_solicitud === 'VACACIONES') {
              endpoint = 'wf_request/'
            }
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar esta solicitud?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete(endpoint + event.record.id)
                    .then(() => {
                      this.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'descargar':
            this.descargarAdjunto(event.record, 'ss/solicitar_vacaciones/download/')
            break
        }
      },
      canApprove (requisicion) {
        let i = parseInt(requisicion.status)
        return this.$userIsInrol(`REQ_WF_${i}`)
      },
      canReject (requisicion) {
        let hrReqPuedeRechazar = parseInt(requisicion.status) <= parseInt(this.status.REQUISICIONES_ETAPA_INICIADA)
        return this.canApprove(requisicion) || (this.$userIsInrol('HRReq') && hrReqPuedeRechazar)
      },
      validaUsuario () {
        this.http = new HttpUtil('ss/valida_usuario')
        this.http.get(null, (response) => {
          if (parseInt(response.data) === 1) {
            this.$router.push({ name: 'Report' })
          }
        }, () => {
          Mensajes.error('Error', 'No fue posible cargar los datos del dashboard')
        })
      }
    },
    computed: {
      mostrarBotonVacaciones () {
        return this.$userIsInrol('SolVacaciones')
      },
      mostrarBotonPermisos () {
        return this.$userIsInrol('SolPermisos')
      },
      mostrarBotonPermisosRecuperacion () {
        return this.$userIsInrol('SolPermisosRecuperacion')
      },
      mostrarDiasPorAusencia () {
        if (this.$isEmpty(this.$getConfigValue('MOSTRAR_DIAS_POR_AUSENCIA')) || this.$getConfigValue('MOSTRAR_DIAS_POR_AUSENCIA') === 'SI') {
          this.mdDiasPorAusencia = 8
          return true
        } else {
          this.mdDiasPorAusencia = 24
          return false
        }
      },
      mostrarActualizarInformacionDashboard () {
        return !!(this.$isEmpty(this.$getConfigValue('MOSTRAR_ACTUALIZAR_INFORMACION_DASHBOARD')) || this.$getConfigValue('MOSTRAR_ACTUALIZAR_INFORMACION_DASHBOARD') === 'SI')
      },
      permisosAlerta () {
        return this.$userIsInrol('CreadorAlertaDashboard')
      },
      canViewObs () {
        return ['PAZ Y SALVO', 'CUENTA DE COBRO'].includes(this.arpobarRechazar.tipo_solicitud)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/Dashboard.vue